import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { TouchableOpacity, ViewStyle } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import styles from './styles';

type Props = {
  isEditable: boolean;
  onRemove?: () => void;
  customStyles?: ViewStyle;
};

const RemoveProduct: React.FC<Props> = ({ isEditable, onRemove, customStyles }) => {
  if (!isEditable) return null;

  return (
    <TouchableOpacity testID="btnRemoveProduct" style={[styles.removeButton, customStyles]} onPress={onRemove}>
      <Ionicons name="remove-circle" size={scale(22)} color={colors.error.rose} />
    </TouchableOpacity>
  );
};

export default RemoveProduct;
